import { useState } from "react";

// Sends a form to Netlify Forms. Submissions appear in Netlify under
// Project > Forms, and can be emailed to info@excellence-care.co.uk.
// Each form must also exist as a hidden copy in public/index.html.
const NetlifyForm = ({ name, successMessage, children, ...rest }) => {
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    setStatus("sending");
    try {
      const response = await fetch("/", {
        method: "POST",
        body: new FormData(form),
      });
      if (!response.ok) throw new Error("Form not sent");
      form.reset();
      setStatus("sent");
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <form
      name={name}
      method="POST"
      data-netlify="true"
      netlify-honeypot="bot-field"
      encType="multipart/form-data"
      onSubmit={handleSubmit}
      {...rest}
    >
      <input type="hidden" name="form-name" value={name} />
      <p style={{ display: "none" }}>
        <label>
          Leave this empty: <input name="bot-field" />
        </label>
      </p>
      {status === "sent" ? (
        <div className="alert alert-success mb-0" role="status">
          {successMessage ||
            "Thank you. Your message has been sent and we will be in touch soon."}
        </div>
      ) : (
        <>
          {children}
          {status === "sending" && (
            <p className="mt-3 mb-0" role="status">
              Sending...
            </p>
          )}
          {status === "error" && (
            <div className="alert alert-danger mt-3 mb-0" role="alert">
              Sorry, something went wrong. Please call us on{" "}
              <a href="tel:+441268988500">01268 988500</a> or email{" "}
              <a href="mailto:info@excellence-care.co.uk">
                info@excellence-care.co.uk
              </a>
              .
            </div>
          )}
        </>
      )}
    </form>
  );
};

export default NetlifyForm;
